import { useNavigate } from "react-router-dom"
import ArrowBackButton from "../../../../components/button/ArrowBackButton"
import useListPhase from "./useListPhase"
import { useEffect, useState } from "react"
import DeleteModal from "../../../../components/modal/DeleteModal"
import { BsPencilSquare, BsFillTrashFill } from 'react-icons/bs'
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

const ListPhase = () => {
    const {
        payload,
        getListPhase,
        deleteProjectPhase
    } = useListPhase()
    const navigate = useNavigate()
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [deleteID, setDeleteID] = useState()
    const [projectPhaseName, setProjectPhaseName] = useState()

    useEffect(() => {
        getListPhase()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div className="d-flex align-items-center mb-4">
                <ArrowBackButton />
                <h3 style={{ margin: 0, fontWeight: 600, color: '#1a1a1a' }}>
                    Manage Phase
                </h3>    
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h5 style={{ 
                        margin: 0,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '18px'
                    }}>
                        Phase Management
                    </h5>
                    <ActionButtonGradient
                        onClick={() => navigate('phase-form')}
                        variant="success"
                        children={"Create Phase"}
                    />
                </div>
                
                <div className="table-responsive">
                    <table className="table align-items-center">
                        <thead>
                            <tr style={{ backgroundColor: '#f8f9fa' }}>
                                <th scope="col" style={{ 
                                    fontWeight: 600, 
                                    color: '#495057', 
                                    padding: '12px',
                                    fontSize: '14px'
                                }}>
                                    Phase
                                </th>
                                <th scope="col" style={{ 
                                    fontWeight: 600, 
                                    color: '#495057', 
                                    padding: '12px',
                                    fontSize: '14px'
                                }}>
                                    Order
                                </th>
                                <th scope="col" style={{ 
                                    fontWeight: 600, 
                                    color: '#495057', 
                                    padding: '12px',
                                    fontSize: '14px',
                                    width: '200px',
                                    textAlign: 'center'
                                }}>
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                payload.map((data) => (
                                    <tr key={data.ID} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                        <td style={{ 
                                            padding: '12px', 
                                            color: '#495057',
                                            fontSize: '14px',
                                            fontWeight: 500
                                        }}>
                                            {data.Name}
                                        </td>
                                        <td style={{ 
                                            padding: '12px', 
                                            color: '#495057',
                                            fontSize: '14px'
                                        }}>
                                            {data.Order}
                                        </td>
                                        <td style={{ padding: '12px', textAlign: 'center' }}>
                                            <div className="d-flex gap-2 justify-content-center">
                                                <button 
                                                    onClick={() => navigate(`phase-form/${data.ID}`)}
                                                    title="Edit phase"
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #02B4CC',
                                                        backgroundColor: 'transparent',
                                                        color: '#02B4CC',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = '#02B4CC';
                                                        e.currentTarget.style.color = 'white';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = 'transparent';
                                                        e.currentTarget.style.color = '#02B4CC';
                                                    }}
                                                >
                                                    <BsPencilSquare size={14}/>
                                                    Edit
                                                </button>
                                                <button 
                                                    onClick={() =>{
                                                        handleShow()
                                                        setDeleteID(data.ID)
                                                        setProjectPhaseName(data.Name)
                                                    }}
                                                    title="Delete phase"
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #dc3545',
                                                        backgroundColor: 'transparent',
                                                        color: '#dc3545',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = '#dc3545';
                                                        e.currentTarget.style.color = 'white';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = 'transparent';
                                                        e.currentTarget.style.color = '#dc3545';
                                                    }}
                                                >
                                                    <BsFillTrashFill size={14}/>
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            
            <DeleteModal show={show} handleClose={handleClose} handleOk={() => {
                handleClose()
                deleteProjectPhase(deleteID)
            }} title={projectPhaseName}/>
        </div>
    )
}

export default ListPhase